/** QP-172 — Portfolio group view (all portfolios under one goal). */

import { useFlowNavigation } from "@/components/flow/flow-navigation-context";
import { PortfolioRow } from "./portfolio-list-row";
import type { PortfolioListGoal } from "./types";

type PortfolioGroupViewProps = {
  goal: PortfolioListGoal;
  portfolios: any[];
  showGoalName: boolean;
  showAmount: boolean;
  showFrequency: boolean;
  showDates: boolean;
  language: string;
};

export function PortfolioGroupView({
  goal,
  portfolios,
  showGoalName,
  showAmount,
  showFrequency,
  showDates,
  language,
}: PortfolioGroupViewProps) {
  const flowNav = useFlowNavigation();

  return (
    <div>
      {showGoalName && (
        <h4 className="text-sm font-medium text-muted-foreground mb-2">{goal.name}</h4>
      )}
      <div className="space-y-1">
        {portfolios.map((p: any) => (
          <PortfolioRow
            key={p.id}
            portfolio={p}
            showAmount={showAmount}
            showFrequency={showFrequency}
            showDates={showDates}
            language={language}
            onNavigate={flowNav ? () => flowNav.navigateToPortfolio(goal.id, p.id) : undefined}
          />
        ))}
      </div>
    </div>
  );
}
